import axios, { ACCESS, getCookie, REFRESH, setCookie, withRetry } from './axios'
import { DEVELOPMENT, IUser } from "../utils";
import { AxiosError } from 'axios';


export async function getUser(): Promise<IUser | undefined> {
  if (process.env.REACT_APP_MODE === DEVELOPMENT) {
    return fakeUser
  }

  try {
    const res = await withRetry(async (instance) => {return instance.get('/user')})
    const user = res.data
  
    return user
  } catch (err) {
    return;
  }
}

export async function createAccaunt(email: string, password: string): Promise<boolean> {
  if (process.env.REACT_APP_MODE === DEVELOPMENT) {
    return true
  }

  const res = await axios.post('user/accaunt/create', {email, password})
  return res.status === 200;
}


export async function confirmAccaunt(token: string): Promise<{error: boolean, message?: string}> {
  if (process.env.REACT_APP_MODE === DEVELOPMENT) {
    return {error: false}
  }

  try {
    const res = await axios.post('user/accaunt/confirm', {token})
    const {error, message} = res.data
    return {error, message}
  } catch (e) {
    if (e instanceof AxiosError) {
      return e.response?.data
    }

    return {error: true, message: 'Произошла ошибка'}
  }

}

export async function login(email: string, password: string): Promise<boolean> {
  if (process.env.REACT_APP_MODE === DEVELOPMENT) {
    return true
  }

  const res = await axios.post('user/login', {email, password})

  const {access, refresh} = res.data
  setCookie(REFRESH, refresh)
  localStorage.setItem(ACCESS, access)

  return res.status === 200;
}


export async function logout(): Promise<boolean> {
  if (process.env.REACT_APP_MODE === DEVELOPMENT) {
    return true
  }

  const res = await withRetry(async (instance) => {return instance.post('user/logout', {refresh: getCookie(REFRESH)})})
  setCookie(REFRESH, '')
  localStorage.setItem(ACCESS, '')

  return res.status === 200;
}


export async function buySubscription(subscriptionId: string): Promise<void> {
  if (process.env.REACT_APP_MODE === DEVELOPMENT) {
    return
  }

  await withRetry(async (instance) => {return instance.post('/user/buy', {subscriptionId})} )
  return;
}

var fakeUser: IUser = {
  subscriptionEnds: new Date(),
  id: 1,
  accauntId: "accauntId"
}